var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from 'react';
import TableHeaderRow from './TableHeaderRow';
import * as PropTypes from 'prop-types';
function getHeaderRows(_a) {
    var _b = _a.columns, columns = _b === void 0 ? [] : _b, _c = _a.currentRow, currentRow = _c === void 0 ? 0 : _c, _d = _a.rows, rows = _d === void 0 ? [] : _d, _e = _a.isLast, isLast = _e === void 0 ? true : _e;
    // eslint-disable-next-line no-param-reassign
    rows[currentRow] = rows[currentRow] || [];
    columns.forEach(function (column, i) {
        if (column.rowSpan && rows.length < column.rowSpan) {
            while (rows.length < column.rowSpan) {
                rows.push([]);
            }
        }
        var cellIsLast = isLast && i === columns.length - 1;
        var cell = {
            key: column.key,
            className: column.className || '',
            children: column.title,
            isLast: cellIsLast,
            column: column,
        };
        if (column.children) {
            getHeaderRows({
                columns: column.children,
                currentRow: currentRow + 1,
                rows: rows,
                isLast: cellIsLast,
            });
        }
        if ('colSpan' in column) {
            cell.colSpan = column.colSpan;
        }
        if ('rowSpan' in column) {
            cell.rowSpan = column.rowSpan;
        }
        if (cell.colSpan !== 0) {
            rows[currentRow].push(cell);
        }
    });
    return rows.filter(function (row) { return row.length > 0; });
}
var TableHeader = /** @class */ (function (_super) {
    __extends(TableHeader, _super);
    function TableHeader(props) {
        return _super.call(this, props) || this;
    }
    TableHeader.prototype.render = function () {
        var _a = this.props, columns = _a.columns, fixed = _a.fixed, expander = _a.expander;
        var table = this.context.table;
        var showHeader = table.props.showHeader;
        if (!showHeader) {
            return null;
        }
        var rows = getHeaderRows({ columns: columns });
        expander && expander.renderExpandIndentCell(rows, fixed);
        return (React.createElement("thead", null, rows.map(function (row, index) { return (React.createElement(TableHeaderRow, { row: row, rows: rows, key: index, fixed: fixed })); })));
    };
    TableHeader.contextTypes = {
        table: PropTypes.any,
    };
    return TableHeader;
}(Component));
export { TableHeader };
